import React from 'react';
import styles from './KPISwitch.module.css';

function KPISwitch({ value, onChange }) {
  const handleChange = () => {
    onChange(!value);
  };

  return (
    <div className={styles.root}>
      <span className={styles.label}>Parameters/KPIs</span>
      <label className={styles.switch}>
        <input type="checkbox" checked={!value} className={styles.input} onChange={handleChange} />
        <span className={styles.slider}></span>
      </label>
    </div>
  );
}

export default KPISwitch;
